import React from "react";
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Select, Table, Icon, Badge} from 'antd';
import BudgetList from "./budget/BudgetList";
import BudgetEdit from "./budget/BudgetEdit";


const Option = Select.Option;
const uri_budget = URI_SETUP+"budget";

class Budget extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_active              : "budget-list",
            budget_list                 : [],
            budget_lst_rows             : [],
            reference_years             : [],
            budget_to_remove            : null,
            status_remove_item_modal    : "hide",
            active_budget               : {
                                            period              : "",
                                            year                : "",
                                            reference_year      : "",
                                            depth               : "",
                                            capture_format      : "",
                                            expected_growth     : 0,
                                            growth              : 0,
                                            matrix              : [],
                                            status              : "draft"
                                        }
            }
        this.setActiveBudgetSection = this.setActiveBudgetSection.bind(this);
        this.updateActiveBudget = this.updateActiveBudget.bind(this);
        this.resetActiveBudget = this.resetActiveBudget.bind(this);
    }

    componentWillMount(){
        this.startBudgetSetup();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hotel_selected != this.props.hotel_selected) {
            this.startBudgetSetup();
        }
    }

    // ----------------------- Handlers -----------------------

    handleNewBudget(e) {
        let self = this;
        e.preventDefault();
        self.resetActiveBudget();
        self.setActiveBudgetSection("budget-edit");
    }

    HandlerBudgetEdit(row){
        let self = this;
        self.setState({ 
            active_budget : row
            })
        self.setActiveBudgetSection("budget-edit");
    }

    handleRemoveItem(_id) {
        let self = this;
        self.setState({ 
            status_remove_item_modal        : "",
            background_filter               : "blur",
            budget_to_remove                : _id
            })
        
    }

    // ----------------------- Functions -----------------------

    resetActiveBudget(){
        let self = this;
        self.setState({ 
            active_budget    : {
                                period              : "",
                                year                : "",
                                reference_year      : "",
                                depth               : "",
                                capture_format      : "",
                                expected_growth     : 0,
                                growth              : 0,
                                matrix              : [],
                                status              : "draft"
                            }
            })
    }
    
    updateActiveBudget(active_budget){
        let self = this;
        self.setState({ 
            active_budget      : active_budget
            })
    }

    startBudgetSetup(){
        let self = this;
        axios.get(uri_budget, { 
            params: {
                api_token       : localStorage.getItem("api_token"),
                mode            : "define",
                property_id     : self.props.hotel_selected
            }
        }).then(request => { 
            let budget_lst_rows=self.mapBudgetRows(request.data.budget_list)
            self.setState({ 
                budget_list                : request.data.budget_list,
                budget_lst_rows            : budget_lst_rows,
                reference_years            : request.data.reference_years,
            }) 
        })
    }

    mapBudgetRows(budget_list){
        let maped_rows=[];
        let maped_row=[];
        let status="";
        let self=this;
        budget_list.map(function(row, i) {
            status = (row.status=='draft')? "warning" : "success";
            maped_row={
                key                     : i,
                _id                     : row._id,
                year                    : <span><Badge status={status} /> {row.year}</span>,
                created_by              : row.created_by.name,
                period                  : row.period,
                growth                  : row.growth,
                capture_format          : row.capture_format,
                reference_years         : row.reference_year,
                created_at              : row.created_at.substring(0,10),
                actions                 : <div>
                                            <i className="fa fa-edit edit clickable" onClick={self.HandlerBudgetEdit.bind(self,row)} ></i> 
                                            <i className="fa fa-times-circle remove clickable" onClick={self.handleRemoveItem.bind(self,row._id)} ></i> 
                                          </div>
                
            };
            maped_rows.push(maped_row);
            });
        return maped_rows;
    }
    
    setActiveBudgetSection(section){
        let self = this;
        self.setState({ 
            section_active      : section
            })
    }

    confirmItemDeletion(e) {
        let self = this;
        e.preventDefault();
        var qs = require("qs"); 

        const valuesToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token")
        });

        axios.post(uri_budget+"/"+self.state.budget_to_remove+"/destroy", valuesToSent)
            .then(request => {
                let budget_lst_rows=self.mapBudgetRows(request.data)
                self.setState({     
                    status_remove_item_modal        : "hide",
                    background_filter               : "",
                    budget_lst_rows                 : budget_lst_rows,
                    budget_list                     : request.data
                }) 

        })
        //self.handleCatalogSelector(this.state.selected_catalog);
    }

    cancelConfirmItemDeletion(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_remove_item_modal    : "hide",
            background_filter           : ""
            })
    }

    // ----------------------- Renders -----------------------

    renderConfirmItemDeletion() {
        return <div className="box notifications col-md-4 ">
                    <h3>NOTIFICATION <i className="fa fa-times-circle" onClick={this.cancelConfirmItemDeletion.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="brand_form" onSubmit={this.confirmItemDeletion.bind(this)}>
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <h4>Are you sure to continue?</h4>
                                    <p>By confirming this proccess you accept to remove all the dependences for this budget</p>
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelConfirmItemDeletion.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="blue">CONFIRM</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="top-form ">
                            <div className="form-row">
                                <div className="col col-md-3">
                                    {this.props.renderSelectHotels()}
                                </div>
                                <div className="col col-md-3">
                                    <button className={"blue " + this.state.status_new_budget} onClick={this.handleNewBudget.bind(this)} >NEW BUDGET</button>
                                </div>
                            </div>
                    </div>
                   
                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Budget</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>Now, manage your sales budget, </strong> <br/> If you already have historical reservations information, Magnum Leap helps you with relevant data to setup your next year budget, you can set up by different periods divided by segment or agency. </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12"> 
                        <div className="layout-budget">
                            { this.state.section_active == "budget-list" &&
                            <div className={"budget-list "  + (this.state.section_active !== "budget-list" ? "hide" : "")}>
                                <BudgetList
                                    setActiveBudgetSection = {this.setActiveBudgetSection}
                                    app={this}
                                    handleNotification = {this.props.handleNotification}
                                    
                                    
                                />
                            </div>
                            }
                            { this.state.section_active == "budget-edit" &&
                            <div className={"budget-edit "  + (this.state.section_active !== "budget-edit" ? "hide" : "")}>
                                <BudgetEdit
                                    setActiveBudgetSection = {this.setActiveBudgetSection}
                                    updateActiveBudget = {this.updateActiveBudget}
                                    resetActiveBudget  = {this.resetActiveBudget}
                                    app={this}
                                    active_budget = {this.state.active_budget}
                                    hotel_selected = {this.props.hotel_selected}
                                    handleNotification = {this.props.handleNotification}
                                    
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div className={"modal " + this.state.status_remove_item_modal}> 
                    {this.renderConfirmItemDeletion()}
                </div>

            </section>
        )
    }

}

export default Budget


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/Budget.js